import { useEffect, useMemo, useState } from 'react'
import {
  FileCog, Plus, Pencil, Trash2, UserPlus, UserMinus, Play, Building2, User, Calendar, MapPin, ToggleLeft,
  Briefcase, ArrowDownAZ, Users, ListChecks, FileText, FileSpreadsheet, ChevronUp, ChevronDown, ChevronsRight, ChevronsLeft,
} from 'lucide-react'
import api from '../services/api'
import LookupSelect from '../components/LookupSelect'
import { useEmpresa } from '../contexts/EmpresaContext'
import { Linha } from './LancamentoDepositos'
import { SeletorMultiplo } from './RelatorioConsumoArla'

// Gerador de Relatórios dos Funcionários (WGERRELE / WGERREL / WGERFIL do ERP) — mesmas tabelas gerrel/gerre1/gerusu

interface Rel { relcod: number; reldes: string; reltit: string }
interface Campo { cam: string; rot: string; tam: number }
interface Detalhe extends Rel { campos: Campo[]; usuarios: { cod: string; nome: string | null }[] }
interface Resultado { relcod: number; titulo: string; colunas: { rot: string; tipo: string }[]; linhas: string[][] }

const erroApi = (e: any, padrao: string) => e?.response?.data?.error || padrao

const btnAcao: React.CSSProperties = { display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }

export default function GeradorRelatorios() {
  const [lista, setLista] = useState<Rel[]>([])
  const [admin, setAdmin] = useState(false)
  const [busca, setBusca] = useState('')
  const [sel, setSel] = useState<number | null>(null)
  const [erro, setErro] = useState('')
  const [editor, setEditor] = useState<{ relcod: number | null } | null>(null)
  const [copiar, setCopiar] = useState(false)
  const [remover, setRemover] = useState(false)
  const [executar, setExecutar] = useState<Rel | null>(null)

  async function carregar() {
    try {
      const r = await api.get('/gerador-relatorios')
      setLista(r.data.relatorios)
      setAdmin(r.data.admin)
    } catch (e) {
      setErro(erroApi(e, 'Erro ao carregar os relatórios.'))
    }
  }
  useEffect(() => { carregar() }, [])

  const filtrada = useMemo(() => {
    const b = busca.trim().toUpperCase()
    return b ? lista.filter(r => r.reldes.toUpperCase().includes(b) || String(r.relcod) === b) : lista
  }, [lista, busca])
  const selecionado = lista.find(r => r.relcod === sel) ?? null

  async function excluirSistema() {
    if (!selecionado) return
    if (!window.confirm(`Deseja excluir do Sistema o relatório ${selecionado.relcod} e também para todos os outros Usuários?`)) return
    try {
      await api.delete(`/gerador-relatorios/${selecionado.relcod}`)
      setSel(null)
      carregar()
    } catch (e) {
      setErro(erroApi(e, 'Erro ao excluir o relatório.'))
    }
  }

  const th: React.CSSProperties = { padding: '0.5rem 0.7rem', fontSize: '0.68rem', fontWeight: 800, color: '#fff', background: '#1b3f7b', textAlign: 'left', textTransform: 'uppercase', position: 'sticky', top: 0 }
  const td: React.CSSProperties = { padding: '0.4rem 0.7rem', fontSize: '0.84rem', borderBottom: '1px solid #eef2f7' }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
      <div className="modal-box" style={{ width: '100%', maxWidth: 820, maxHeight: 'none', boxShadow: '0 12px 32px -8px rgba(15,23,42,0.18)' }}>
        <div className="modal-header" style={{ background: 'linear-gradient(135deg, #1a6ea8, #14547f)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 34, height: 34, borderRadius: 9, background: 'rgba(255,255,255,0.15)' }}>
              <FileCog size={18} color="#fff" />
            </span>
            <div>
              <h2>Gerador de Relatórios dos Funcionários</h2>
              <div style={{ fontSize: '0.7rem', color: '#dbeafe', marginTop: 2 }}>Monte relatórios escolhendo os campos do cadastro — os mesmos do ERP</div>
            </div>
          </div>
        </div>

        <div className="modal-corpo">
          <div className="field" style={{ maxWidth: 320, marginBottom: '0.8rem' }}>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar código ou descrição" />
          </div>

          <div style={{ border: '1px solid #bfdbfe', borderRadius: 8, maxHeight: 420, overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={{ ...th, width: 80, textAlign: 'right' }}>Código</th><th style={th}>Descrição do Relatório</th></tr></thead>
              <tbody>
                {filtrada.length === 0 && <tr><td colSpan={2} style={{ ...td, textAlign: 'center', color: '#94a3b8', padding: '1.2rem' }}>Nenhum relatório.</td></tr>}
                {filtrada.map((r, i) => {
                  const ativo = r.relcod === sel
                  return (
                    <tr key={r.relcod} onClick={() => setSel(r.relcod)} onDoubleClick={() => setExecutar(r)}
                      style={{ cursor: 'pointer', background: ativo ? '#dbeafe' : i % 2 ? '#f5f9fd' : '#fff' }}>
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: '#1b3f7b' }}>{r.relcod}</td>
                      <td style={{ ...td, fontWeight: ativo ? 700 : 400 }}>{r.reldes}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 6 }}>Clique para selecionar; duplo clique para gerar.</div>

          {erro && (
            <div style={{ marginTop: '0.9rem', fontSize: '0.8rem', fontWeight: 600, padding: '0.55rem 0.9rem', borderRadius: 8, background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca' }}>
              {erro}
            </div>
          )}
        </div>

        <div className="modal-footer" style={{ flexWrap: 'wrap' }}>
          <button className="btn btn-primary" style={btnAcao} disabled={!selecionado} onClick={() => setExecutar(selecionado)}><Play size={15} /> Gerar</button>
          <button className="btn btn-secondary" style={btnAcao} onClick={() => setEditor({ relcod: null })}><Plus size={15} /> Criar Novo</button>
          <button className="btn btn-secondary" style={btnAcao} disabled={!selecionado} onClick={() => setEditor({ relcod: sel })}><Pencil size={15} /> Alterar</button>
          <button className="btn btn-secondary" style={btnAcao} disabled={!selecionado} onClick={() => setCopiar(true)}><UserPlus size={15} /> Copiar para Usuário</button>
          {admin && <button className="btn btn-secondary" style={btnAcao} disabled={!selecionado} onClick={() => setRemover(true)}><UserMinus size={15} /> Excluir do Usuário</button>}
          {admin && <button className="btn" style={{ ...btnAcao, background: '#dc2626', color: '#fff' }} disabled={!selecionado} onClick={excluirSistema}><Trash2 size={15} /> Excluir do Sistema</button>}
        </div>
      </div>

      {executar && <PainelExecucao key={executar.relcod} rel={executar} onFechar={() => setExecutar(null)} />}

      {editor && <EditorRelatorio relcod={editor.relcod} onClose={() => setEditor(null)}
        onSalvo={relcod => { setEditor(null); setSel(relcod); carregar() }} />}
      {copiar && selecionado && <CopiarUsuario rel={selecionado} onClose={() => setCopiar(false)} />}
      {remover && selecionado && <RemoverUsuario rel={selecionado} onClose={() => setRemover(false)} />}
    </div>
  )
}

// ── Criar / Alterar (WGERREL) ──

function EditorRelatorio({ relcod, onClose, onSalvo }: { relcod: number | null; onClose: () => void; onSalvo: (relcod: number) => void }) {
  const [catalogo, setCatalogo] = useState<Campo[]>([])
  const [reltit, setReltit] = useState('')
  const [reldes, setReldes] = useState('')
  const [campos, setCampos] = useState<Campo[]>([])
  const [disp, setDisp] = useState<string | null>(null)
  const [noRel, setNoRel] = useState<string | null>(null)
  const [erro, setErro] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    api.get('/gerador-relatorios/campos').then(r => setCatalogo(r.data)).catch(() => {})
    if (relcod) {
      api.get(`/gerador-relatorios/${relcod}`).then(r => {
        setReltit(r.data.reltit); setReldes(r.data.reldes); setCampos(r.data.campos)
      }).catch(e => setErro(erroApi(e, 'Erro ao carregar o relatório.')))
    }
  }, [relcod])

  const adicionar = () => {
    const c = catalogo.find(x => x.cam === disp)
    if (!c) return
    if (campos.some(x => x.cam === c.cam)) { setErro('Este campo já foi inserido no relatório!'); return }
    setErro(''); setCampos([...campos, c]); setNoRel(c.cam)
  }
  const removerCampo = () => { if (noRel) { setCampos(campos.filter(x => x.cam !== noRel)); setNoRel(null) } }
  const mover = (d: -1 | 1) => {
    const i = campos.findIndex(x => x.cam === noRel)
    const j = i + d
    if (i < 0 || j < 0 || j >= campos.length) return
    const n = [...campos];
    [n[i], n[j]] = [n[j], n[i]]
    setCampos(n)
  }

  async function salvar() {
    setErro('')
    if (!reltit.trim()) return setErro('Informe um Título para o Relatório.')
    if (!campos.length) return setErro('Insira ao menos um campo para o relatório.')
    setSalvando(true)
    try {
      const body = { reltit, reldes: reldes || reltit, campos: campos.map(c => c.cam) }
      if (relcod) { await api.put(`/gerador-relatorios/${relcod}`, body); onSalvo(relcod) }
      else { const r = await api.post('/gerador-relatorios', body); onSalvo(r.data.relcod) }
    } catch (e) {
      setErro(erroApi(e, 'Erro ao salvar o relatório.'))
    } finally {
      setSalvando(false)
    }
  }

  const caixa: React.CSSProperties = { border: '1px solid #bfdbfe', borderRadius: 8, height: 300, overflowY: 'auto', background: '#fff' }
  const item = (ativo: boolean, usado = false): React.CSSProperties => ({
    padding: '0.32rem 0.6rem', fontSize: '0.82rem', cursor: 'pointer', borderBottom: '1px solid #f1f5f9',
    background: ativo ? '#1b3f7b' : 'transparent', color: ativo ? '#fff' : usado ? '#94a3b8' : '#1f2937',
  })
  const btnSeta: React.CSSProperties = { padding: '0.35rem 0.55rem', display: 'inline-flex', justifyContent: 'center' }

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 760, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>{relcod ? `Alterar Relatório ${relcod}` : 'Novo Relatório'}</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>WGERREL</span>
            <button className="modal-fechar" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal-corpo" style={{ overflowY: 'auto' }}>
          {relcod != null && (
            <div style={{ fontSize: '0.78rem', fontWeight: 600, padding: '0.5rem 0.8rem', borderRadius: 8, background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', marginBottom: '0.8rem' }}>
              As alterações feitas neste relatório vão valer para todos os outros usuários que usam o mesmo.
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem', marginBottom: '0.9rem' }}>
            <div className="field-cad">
              <label>Título</label>
              <input value={reltit} maxLength={40} onChange={e => setReltit(e.target.value)} onBlur={() => { if (!reldes.trim()) setReldes(reltit) }} style={{ width: '100%', boxSizing: 'border-box' }} />
            </div>
            <div className="field-cad">
              <label>Descrição</label>
              <input value={reldes} maxLength={40} onChange={e => setReldes(e.target.value)} style={{ width: '100%', boxSizing: 'border-box' }} />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr auto', gap: '0.6rem', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#475569', marginBottom: 4, textTransform: 'uppercase' }}>Campos disponíveis</div>
              <div style={caixa}>
                {catalogo.map(c => {
                  const usado = campos.some(x => x.cam === c.cam)
                  return <div key={c.cam} style={item(disp === c.cam, usado)} onClick={() => setDisp(c.cam)} onDoubleClick={() => { setDisp(c.cam); if (!usado) { setCampos([...campos, c]); setNoRel(c.cam) } }}>{c.rot}</div>
                })}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 18 }}>
              <button className="btn btn-secondary" style={btnSeta} title="Adicionar" onClick={adicionar} disabled={!disp}><ChevronsRight size={16} /></button>
              <button className="btn btn-secondary" style={btnSeta} title="Remover" onClick={removerCampo} disabled={!noRel}><ChevronsLeft size={16} /></button>
            </div>
            <div>
              <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#475569', marginBottom: 4, textTransform: 'uppercase' }}>Campos do relatório ({campos.length})</div>
              <div style={caixa}>
                {campos.map((c, i) => (
                  <div key={c.cam} style={item(noRel === c.cam)} onClick={() => setNoRel(c.cam)} onDoubleClick={() => { setCampos(campos.filter(x => x.cam !== c.cam)); setNoRel(null) }}>
                    <span style={{ opacity: 0.6, marginRight: 6 }}>{i + 1}.</span>{c.rot}
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 18 }}>
              <button className="btn btn-secondary" style={btnSeta} title="Subir campo" onClick={() => mover(-1)} disabled={!noRel}><ChevronUp size={16} /></button>
              <button className="btn btn-secondary" style={btnSeta} title="Descer campo" onClick={() => mover(1)} disabled={!noRel}><ChevronDown size={16} /></button>
            </div>
          </div>

          {erro && <div style={{ marginTop: '0.9rem', fontSize: '0.8rem', fontWeight: 600, padding: '0.55rem 0.9rem', borderRadius: 8, background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca' }}>{erro}</div>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : relcod ? 'Salvar alterações' : 'Criar relatório'}</button>
        </div>
      </div>
    </div>
  )
}

// ── Copiar para Usuário (WGERCOP) / Excluir do Usuário (WGEREXC) ──

function CopiarUsuario({ rel, onClose }: { rel: Rel; onClose: () => void }) {
  const [usuarios, setUsuarios] = useState<{ cod: string; nome: string }[]>([])
  const [jaTem, setJaTem] = useState<string[]>([])
  const [cod, setCod] = useState('')
  const [msg, setMsg] = useState<{ ok: boolean; t: string } | null>(null)

  useEffect(() => {
    api.get('/gerador-relatorios/usuarios').then(r => setUsuarios(r.data)).catch(() => {})
    api.get(`/gerador-relatorios/${rel.relcod}`).then(r => setJaTem(r.data.usuarios.map((u: any) => u.cod))).catch(() => {})
  }, [rel.relcod])

  async function copiar() {
    setMsg(null)
    try {
      await api.post(`/gerador-relatorios/${rel.relcod}/usuarios`, { codusu: cod })
      setJaTem([...jaTem, cod])
      setMsg({ ok: true, t: 'Relatório copiado para o usuário.' })
      setCod('')
    } catch (e) {
      setMsg({ ok: false, t: erroApi(e, 'Erro ao copiar.') })
    }
  }

  return (
    <ModalSimples titulo={`Copiar relatório ${rel.relcod} para usuário`} prg="WGERCOP" onClose={onClose}
      rodape={<button className="btn btn-primary" onClick={copiar} disabled={!cod}>Copiar</button>}>
      <div style={{ fontSize: '0.85rem', marginBottom: '0.7rem', color: '#475569' }}>{rel.reldes}</div>
      <div className="field-cad">
        <label>Usuário</label>
        <select value={cod} onChange={e => setCod(e.target.value)} style={{ width: '100%' }}>
          <option value="">Selecione...</option>
          {usuarios.filter(u => !jaTem.includes(u.cod)).map(u => <option key={u.cod} value={u.cod}>{u.nome}</option>)}
        </select>
      </div>
      {msg && <div style={{ marginTop: '0.7rem', fontSize: '0.8rem', fontWeight: 600, color: msg.ok ? '#047857' : '#991b1b' }}>{msg.t}</div>}
    </ModalSimples>
  )
}

function RemoverUsuario({ rel, onClose }: { rel: Rel; onClose: () => void }) {
  const [usuarios, setUsuarios] = useState<{ cod: string; nome: string | null }[] | null>(null)
  const [erro, setErro] = useState('')

  const carregar = () => api.get(`/gerador-relatorios/${rel.relcod}`).then(r => setUsuarios(r.data.usuarios)).catch(e => setErro(erroApi(e, 'Erro ao carregar.')))
  useEffect(() => { carregar() }, [rel.relcod])

  async function tirar(cod: string, nome: string) {
    if (!window.confirm(`Tirar o relatório ${rel.relcod} do usuário ${nome}?`)) return
    try {
      await api.delete(`/gerador-relatorios/${rel.relcod}/usuarios/${encodeURIComponent(cod)}`)
      carregar()
    } catch (e) {
      setErro(erroApi(e, 'Erro ao remover.'))
    }
  }

  return (
    <ModalSimples titulo={`Usuários com o relatório ${rel.relcod}`} prg="WGEREXC" onClose={onClose}>
      <div style={{ fontSize: '0.85rem', marginBottom: '0.7rem', color: '#475569' }}>{rel.reldes}</div>
      {usuarios === null ? <p style={{ color: '#6b7280' }}>Carregando...</p> : usuarios.length === 0 ? (
        <p style={{ color: '#94a3b8' }}>Nenhum usuário tem este relatório.</p>
      ) : (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8 }}>
          {usuarios.map(u => (
            <div key={u.cod} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.4rem 0.7rem', borderBottom: '1px solid #f1f5f9', fontSize: '0.85rem' }}>
              <span>{u.nome || <em style={{ color: '#94a3b8' }}>usuário {u.cod} (não cadastrado)</em>}</span>
              <button className="btn" style={{ background: '#dc2626', color: '#fff', padding: '0.2rem 0.6rem', fontSize: '0.75rem' }} onClick={() => tirar(u.cod, u.nome || u.cod)}>Tirar</button>
            </div>
          ))}
        </div>
      )}
      {erro && <div style={{ marginTop: '0.7rem', fontSize: '0.8rem', fontWeight: 600, color: '#991b1b' }}>{erro}</div>}
    </ModalSimples>
  )
}

function ModalSimples({ titulo, prg, onClose, rodape, children }: { titulo: string; prg: string; onClose: () => void; rodape?: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 480, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>{titulo}</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>{prg}</span>
            <button className="modal-fechar" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="modal-corpo" style={{ overflowY: 'auto' }}>{children}</div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
          {rodape}
        </div>
      </div>
    </div>
  )
}

// ── Filtros e execução (WGERFIL) ──

function PainelExecucao({ rel, onFechar }: { rel: Rel; onFechar: () => void }) {
  const { empresas, empresaCod } = useEmpresa()
  const [empresasSel, setEmpresasSel] = useState<string[]>([])
  const [funcCod, setFuncCod] = useState('')
  const [funcNome, setFuncNome] = useState('')
  const [adm1, setAdm1] = useState('')
  const [adm2, setAdm2] = useState('')
  const [val1, setVal1] = useState('')
  const [val2, setVal2] = useState('')
  const [cidade, setCidade] = useState('')
  const [sexo, setSexo] = useState('')
  const [situacao, setSituacao] = useState('A')
  const [cargosSel, setCargosSel] = useState<string[]>([])
  const [ordem, setOrdem] = useState<'C' | 'N'>('C')
  const [totais, setTotais] = useState(true)
  const [cargos, setCargos] = useState<{ cod: string; des: string }[]>([])
  const [cidades, setCidades] = useState<{ cod: string; des: string }[]>([])
  const [res, setRes] = useState<Resultado | null>(null)
  const [carregando, setCarregando] = useState(false)
  const [gerando, setGerando] = useState<'' | 'pdf' | 'excel'>('')
  const [erro, setErro] = useState('')

  useEffect(() => {
    api.get('/funcionarios/cargos').then(r => setCargos(r.data.map((c: any) => ({ cod: c.catcod, des: c.catdes })))).catch(() => {})
    api.get('/gerador-relatorios/cidades').then(r => setCidades(r.data)).catch(() => {})
  }, [])

  const params = () => ({
    motcod: funcCod, empresas: empresasSel.join(','), admissao1: adm1, admissao2: adm2, validade1: val1, validade2: val2,
    cidade, sexo, situacao, cargos: cargosSel.join(','), ordem, totais: totais ? '1' : '0', empresa: empresaCod ?? 1,
  })

  async function gerar() {
    setErro('')
    setCarregando(true)
    try {
      const r = await api.get(`/gerador-relatorios/${rel.relcod}/executar`, { params: params() })
      setRes(r.data)
    } catch (e) {
      setRes(null)
      setErro(erroApi(e, 'Erro ao gerar relatório.'))
    } finally {
      setCarregando(false)
    }
  }

  async function exportar(formato: 'pdf' | 'excel') {
    setErro('')
    setGerando(formato)
    try {
      const r = await api.get(`/gerador-relatorios/${rel.relcod}/executar`, { params: { ...params(), formato }, responseType: 'blob' })
      const tipoArq = formato === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const url = URL.createObjectURL(new Blob([r.data], { type: tipoArq }))
      if (formato === 'pdf') {
        window.open(url, '_blank')
      } else {
        const a = document.createElement('a')
        a.href = url
        a.download = `relatorio-${rel.relcod}.xlsx`
        a.click()
        URL.revokeObjectURL(url)
      }
    } catch {
      setErro(formato === 'pdf' ? 'Erro ao gerar PDF.' : 'Erro ao gerar Excel.')
    } finally {
      setGerando('')
    }
  }

  const periodo = (a: string, setA: (v: string) => void, b: string, setB: (v: string) => void) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
      <input type="date" value={a} onChange={e => setA(e.target.value)} style={{ maxWidth: 170 }} />
      <span style={{ fontSize: '0.8rem', color: '#57606f' }}>a</span>
      <input type="date" value={b} onChange={e => setB(e.target.value)} style={{ maxWidth: 170 }} />
      {!a && !b && <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>em branco = todas</span>}
    </div>
  )

  const th: React.CSSProperties = { padding: '0.5rem 0.6rem', fontSize: '0.68rem', fontWeight: 800, color: '#fff', background: '#1b3f7b', textAlign: 'left', whiteSpace: 'nowrap', textTransform: 'uppercase' }
  const td: React.CSSProperties = { padding: '0.4rem 0.6rem', fontSize: '0.82rem', borderBottom: '1px solid #eef2f7', whiteSpace: 'nowrap' }

  return (
    <>
      <div className="modal-box" style={{ width: '100%', maxWidth: 820, maxHeight: 'none', boxShadow: '0 12px 32px -8px rgba(15,23,42,0.18)' }}>
        <div className="modal-header" style={{ background: 'linear-gradient(135deg, #1a6ea8, #14547f)', gap: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', minWidth: 0 }}>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 34, height: 34, borderRadius: 9, background: 'rgba(255,255,255,0.15)', flexShrink: 0 }}>
              <ListChecks size={18} color="#fff" />
            </span>
            <div style={{ minWidth: 0 }}>
              <h2>{rel.relcod} · {rel.reltit}</h2>
              <div style={{ fontSize: '0.7rem', color: '#dbeafe', marginTop: 2 }}>Filtros do relatório</div>
            </div>
          </div>
          <button className="modal-fechar" style={{ marginLeft: 'auto' }} onClick={onFechar}>✕</button>
        </div>

        <div className="modal-corpo">
          <Linha label="Estabelecimento" icon={Building2}>
            <SeletorMultiplo opcoes={empresas.map(e => ({ cod: String(e.empcod), des: `${e.empcod} — ${e.empfan?.trim() || e.empnom?.trim()}` }))}
              selecionados={empresasSel} onChange={setEmpresasSel} placeholderBusca="Buscar empresa..." />
          </Linha>
          <Linha label="Funcionário" icon={User}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <div style={{ minWidth: 300 }}>
                <LookupSelect endpoint="/funcionarios" extraParams={{ status: 'todos' }} codKey="motcod" descKey="motnome" tagKey="motcod"
                  codValue={funcCod} descValue={funcNome} onSelect={(cod, desc) => { setFuncCod(cod); setFuncNome(desc) }}
                  placeholder="Todos" listWidth={320} />
              </div>
              {funcCod
                ? <button className="btn btn-secondary" style={{ padding: '0.25rem 0.6rem', fontSize: '0.72rem' }} onClick={() => { setFuncCod(''); setFuncNome('') }}>Todos</button>
                : <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>em branco = todos</span>}
            </div>
          </Linha>
          <Linha label="Admissão" icon={Calendar}>{periodo(adm1, setAdm1, adm2, setAdm2)}</Linha>
          <Linha label="Validade CNH" icon={Calendar}>{periodo(val1, setVal1, val2, setVal2)}</Linha>
          <Linha label="Cidade" icon={MapPin}>
            <select value={cidade} onChange={e => setCidade(e.target.value)} style={{ maxWidth: 320 }}>
              <option value="">Todas</option>
              {cidades.map(c => <option key={c.cod} value={c.cod}>{c.des}</option>)}
            </select>
          </Linha>
          <Linha label="Sexo" icon={Users}>
            <select value={sexo} onChange={e => setSexo(e.target.value)} style={{ maxWidth: 160 }}>
              <option value="">Ambos</option><option value="M">Masculino</option><option value="F">Feminino</option>
            </select>
          </Linha>
          <Linha label="Situação" icon={ToggleLeft}>
            <select value={situacao} onChange={e => setSituacao(e.target.value)} style={{ maxWidth: 160 }}>
              <option value="A">Ativos</option><option value="I">Inativos</option><option value="">Todos</option>
            </select>
          </Linha>
          <Linha label="Cargo/Função" icon={Briefcase}>
            <SeletorMultiplo opcoes={cargos} selecionados={cargosSel} onChange={setCargosSel} placeholderBusca="Buscar cargo..." />
          </Linha>
          <Linha label="Ordem" icon={ArrowDownAZ}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <select value={ordem} onChange={e => setOrdem(e.target.value as 'C' | 'N')} style={{ maxWidth: 200 }}>
                <option value="C">Código Funcionário</option><option value="N">Nome Funcionário</option>
              </select>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.82rem', cursor: 'pointer' }}>
                <input type="checkbox" checked={totais} onChange={e => setTotais(e.target.checked)} /> Exibir total de registros
              </label>
            </div>
          </Linha>

          {erro && (
            <div style={{ marginTop: '0.9rem', fontSize: '0.8rem', fontWeight: 600, padding: '0.55rem 0.9rem', borderRadius: 8, background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca' }}>
              {erro}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={gerar} disabled={carregando}>{carregando ? 'Gerando...' : 'Gerar'}</button>
          <button className="btn" style={{ background: '#dc2626', color: '#fff', display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
            onClick={() => exportar('pdf')} disabled={!!gerando}>
            <FileText size={15} /> {gerando === 'pdf' ? 'Gerando PDF...' : 'PDF'}
          </button>
          <button className="btn" style={{ background: '#15803d', color: '#fff', display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
            onClick={() => exportar('excel')} disabled={!!gerando}>
            <FileSpreadsheet size={15} /> {gerando === 'excel' ? 'Gerando Excel...' : 'Excel'}
          </button>
        </div>
      </div>

      {res && (
        <div className="modal-box" style={{ width: '100%', maxWidth: 'none', maxHeight: 'none', boxShadow: '0 12px 32px -8px rgba(15,23,42,0.18)' }}>
          <div className="modal-corpo" style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
            <div style={{ fontSize: '1rem', fontWeight: 800, color: '#0f172a' }}>{res.titulo.toUpperCase()}</div>
            {res.linhas.length === 0 && <div style={{ textAlign: 'center', color: '#94a3b8', padding: '1.2rem' }}>Nenhum funcionário encontrado.</div>}
            {res.linhas.length > 0 && (
              <div style={{ overflowX: 'auto', border: '1px solid #bfdbfe', borderRadius: 8 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>{res.colunas.map((c, i) => <th key={i} style={{ ...th, textAlign: c.tipo.startsWith('num') ? 'right' : 'left' }}>{c.rot}</th>)}</tr>
                  </thead>
                  <tbody>
                    {res.linhas.map((l, i) => (
                      <tr key={i} style={{ background: i % 2 ? '#f5f9fd' : '#fff' }}>
                        {l.map((v, j) => <td key={j} style={{ ...td, textAlign: res.colunas[j].tipo.startsWith('num') ? 'right' : 'left' }}>{v}</td>)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {totais && (
              <div style={{ borderRadius: 12, padding: '0.8rem 1.1rem', background: 'linear-gradient(135deg, #0f2a52, #1b3f7b)', color: '#fff', fontWeight: 800, letterSpacing: '0.02em' }}>
                TOTAL DE REGISTROS: {res.linhas.length}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
